import { render, staticRenderFns } from "./admin.clients.edit.page.vue?vue&type=template&id=67f1e40c&scoped=true&"
import script from "./admin.clients.edit.page.vue?vue&type=script&lang=js&"
export * from "./admin.clients.edit.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.clients.edit.page.vue?vue&type=style&index=0&id=67f1e40c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1e40c",
  null
  
)

export default component.exports